import { ActionDescription, ActionKind } from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { SerializedComponent } from "../../components/SerializedApp";
import { ComponentBuilder, WireActionHydrator } from "../components";
import { BaseActionHandler } from "./base";
import { getFeatureSetting } from "../../feature-settings";

export class SignInActionHandler extends BaseActionHandler<ActionDescription> {
    public readonly kind = ActionKind.SignIn;

    public readonly iconName = "01-login-3";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Sign In",
            needsScreenContext: false,
            isLegacy: !getFeatureSetting("signInAction"),
            properties: [],
        };
    }

    public makeAction({ b }: ComponentBuilder): SerializedComponent | undefined {
        // FIXME: This is a shitty way to make a NoAction that doesn't report
        // as a NoAction.  Either add an argument to NoAction or make a separate
        // action.
        return b.actionWithUserSpecificData(b.sequence([b.noAction(), b.noAction()]), b.noAction());
    }

    public inflate(): WireActionHydrator | undefined {
        return vp => {
            if (vp.getIsUserSignedIn()) return undefined;

            return async ab => {
                ab.actionCallbacks.signIn();
                return true;
            };
        };
    }
}
